import { gql } from '@apollo/client';

export const CODE_VALIDATION = gql`
  query ValidateSubscriptionDiscountCodeByToken($code: String!, $priceIds: [String!], $token: String!) {
    validateSubscriptionDiscountCodeByToken(code: $code, priceIds: $priceIds, token: $token) {
      errMsg
      valid
      discount {
        _id
        name
        code
      }
    }
  }
`;

export const ELIGIBILITY = gql`
  query GetEligibleDiscountsByToken($token: String!, $priceIds: [String], $campaignIds: [String]) {
    getEligibleDiscountsByToken(token: $token, campaignIds: $campaignIds, priceIds: $priceIds) {
      _id
      name
      code
      campaignIds
      appliesToPrices
      appliesToProducts
      eligibilityReasons {
        withinPeriod
        neverUsed
        firstSubscription
        withinCycleLimit
        appliesToProducts
        appliesToPrices
        renewalsCountAllowed
      }
    }
  }
`;
